import {STATUS_PENDING} from "./../../actions"
import { connect } from 'react-redux'
import moment from 'moment';

const setIntercom = (auth) => {
    window.Intercom('boot', {
        app_id: window.__react_app_intercom_app_id,
        email: auth.data["http://cloud.netapp.com/user_metadata"].email,
        user_id: auth.data.sub,
        created_at: moment().unix(), //Returns Unix timestamp (in seconds)
    });
};

const setIntercomAnonymous = () => {
    window.Intercom('boot', {
        app_id: window.__react_app_intercom_app_id,
    });
};

let done = false;
const Intercom = ({auth}) => {
    if(!done && auth.status !== STATUS_PENDING) {
        done = true;

        if(auth.authenticated) {
            setIntercom(auth);
        } else {
            setIntercomAnonymous();
        }
    }
    return "";
};

const mapStateToProps = state => {
    return {
        auth: state.auth
    };
};

export default connect(mapStateToProps)(Intercom);

